import { required, email, length, min } from 'vee-validate/dist/rules';
import { extend, localize } from 'vee-validate';
import id from 'vee-validate/dist/locale/id.json';

extend('required', {
  ...required,
  message: '{_field_} wajib diisi',
});

extend('email', {
  ...email,
  message: 'Isian harus berupa valid email',
});

extend('nik', {
  validate(value) {
    return Number(value) && value.length === 16;
  },
  message: 'Isian NIK harus berupa 16 digit angka',
});

extend('phone', {
  validate(value) {
    return /^(?:\+62|62|0)8\d{7,12}$/.test(value || '');
  },
  message: 'Format no HP tidak valid',
});

extend('length', length);
extend('min', min);

// Install English and Arabic locales.
localize('id', id);
